import Vue, { onBeforeUnmount, ref } from 'vue'

const code = getCurrentDate()

const state = Vue.observable({
    isShow: localStorage.getItem('aad') === 'true',
})

export function useDebug() {
    const input = ref('')
    const isActive = ref(false)

    function close() {
        state.isShow = false
        localStorage.setItem('aad', 'false')
    }

    function onCreated() {
        if (!state.isShow) {
            document.addEventListener('keydown', onKeyDown)
        }
    }

    function onKeyDown(e: KeyboardEvent) {
        if (isActive.value) {
            if (e.key === 'Escape') {
                isActive.value = false
                input.value = ''
            } else {
                input.value = input.value + e.key

                if (input.value === code) {
                    state.isShow = true
                    isActive.value = false
                    input.value = ''
                    document.removeEventListener('keydown', onKeyDown)
                    localStorage.setItem('aad', 'true')
                }
            }
        } else if (e.key === '`') {
            isActive.value = true
        }
    }

    onCreated()

    onBeforeUnmount(() => {
        document.removeEventListener('keydown', onKeyDown)
    })

    return {
        state,
        close,
    }
}

function getCurrentDate() {
    const date = new Date()
    const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`
    const month =
        date.getMonth() + 1 >= 10
            ? date.getMonth() + 1
            : `0${date.getMonth() + 1}`
    const year = date.getFullYear()

    return `${day}${month}${year}`
}
